import FlagType from 'owa-service/lib/contract/FlagType';
import { InstrumentationContext } from 'owa-mail-store';
import { TableView } from 'owa-mail-list-store';
import logUserMailInteraction from '../logUserMailInteraction';

/**
 * @param flagTypeToApply flag type
 * @param instrumentationContexts instrumentation contexts for search scenario
 */
export default function logFlagInstrumentationContext(
    flagTypeToApply: FlagType,
    instrumentationContexts: InstrumentationContext[],
    rowKeys?: string[],
    tableView?: TableView
) {
    let instrumentationFlag;
    switch (flagTypeToApply.FlagStatus) {
        case 'Flagged':
            instrumentationFlag = 'Flag';
            break;
        case 'NotFlagged':
            instrumentationFlag = 'FlagCleared';
            break;
        case 'Complete':
            instrumentationFlag = 'FlagComplete';
            break;
    }
    logUserMailInteraction(rowKeys, tableView, instrumentationContexts, instrumentationFlag);
}
